import { Controller } from "@hotwired/stimulus";

/**
 * Preview Iframe Controller
 * 
 * Manages preview iframes by setting their source from data attributes.
 * Lazy loads iframe content to improve page performance.
 * 
 * Features:
 * - Sets iframe src from data-src attribute on connect
 * - Enables lazy loading of iframe content
 * - Prevents unnecessary iframe loading until needed
 * 
 * Usage: Add data-controller="preview-iframe" to iframe elements with data-src attributes
 */
export default class extends Controller {
  connect() {
    if (!this.element.src) {
      this.element.src = this.element.dataset.src;
    }
  }
} 